/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { Header2, Text, Button } from '../styles/Components'
import { gsColors } from '../styles/Variables'
import { mq } from '../helpers'
import Image from 'next/image'
import styled from '@emotion/styled'

const WhyChecklist = ({ handleClick, image, imageAlt = 'GLAMSQUAD beauty professionals delivering in-home hair, makeup, and nail services', reasons = [], buttonTitle = '', headerTitle }) => {
  return (
    <WhyJoinWrapper>
      <div className="why-content">
        <Header2 margin="0 0 44px 0" color={gsColors.cobalt}>
          {headerTitle}
        </Header2>
        <div className="list">
          { reasons.map((reason, i) => (
            <div className="list-item" key={i}>
              <div className="check-box">
                <img src="/images/checkmark_cobalt.svg" alt="" aria-hidden="true" />
              </div>
              <Text fontSize={24} margin="0 0 0 72px" color={gsColors.cobalt}>
                {reason}
              </Text>
            </div>
          ))}
        </div>
        <Button
          style={{ marginTop: 60 }}
          onClick={handleClick}
          target="_blank"
          outline
          large
          color={gsColors.cobalt}
        >
          {buttonTitle}
        </Button>
      </div>
      <div className="image-placeholder why-glamsquad">
        <Image
          fill
          style={{ objectFit: 'cover ' }}
          src={image}
          alt={imageAlt}
          priority
          quality={100}
        />
      </div>
    </WhyJoinWrapper>
  )
}

const WhyJoinWrapper = styled.section`
  display: flex;
  position: relative;
  width: 100%;
  max-width: 1600px;
  height: auto;
  background-color: ${gsColors.salmon};

  ${mq('max', '768px')} {
    flex-direction: column;
  }

  .why-content {
    flex: 1;
    box-sizing: border-box;
    display: flex;
    flex-basis: 50%;
    flex-direction: column;
    align-items: flex-start;
    padding: 90px;

    ${mq('max', '1024px')} {
      flex-basis: 70%;
    }

    ${mq('max', '768px')} {
      padding: 44px 16px;
      order: 2;
      flex-basis: 100%;
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: 32px;


      .list-item {
        display: flex;
        flex-direction: row;
        align-items: center;

        .check-box {
          height: 40px;
          width: 40px;
          aspect-ratio: 1/1;
          background-color: ${gsColors.cobalt};
          display: flex;
          justify-content: center;
          align-items: center;

          ${mq('max', '768px')} {
            height: 30px;
            width: 30px;

            img {
              height: 30px;
              width: 30px;
            }
          }
        }

        p {
          max-width: 600px;

          ${mq('max', '768px')} {
            margin-left: 40px !important;
          }
        }
      }
    }

    button {

      ${mq('max', '768px')} {
        font-size: 16px;
      }
    }
  }

  .image-placeholder {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-basis: 50%;

    ${mq('max', '1024px')} {
      flex-basis: 30%;
    }

    ${mq('max', '768px')} {
      height: 395px;
      // aspect-ratio: 1;
      flex: none
    }
  }
`

export default WhyChecklist
